import { Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Navbar from './components/Navbar'
import CookieBanner from './components/CookieBanner'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import { lazy, Suspense } from 'react'

// Lazy loaded pages for code splitting
const Home = lazy(() => import('./pages/Home'))
const About = lazy(() => import('./pages/About'))
const Portfolio = lazy(() => import('./pages/Portfolio'))
const Contact = lazy(() => import('./pages/Contact'))
const Services = lazy(() => import('./pages/Services'))
const WebdesignOverview = lazy(() => import('./pages/services/WebdesignOverview'))
const WebdesignService = lazy(() => import('./pages/services/WebdesignService'))
const WordPressService = lazy(() => import('./pages/services/WordPressService'))
const EcommerceOverview = lazy(() => import('./pages/services/EcommerceOverview'))
const ShopifyService = lazy(() => import('./pages/services/ShopifyService'))
const WooCommerceService = lazy(() => import('./pages/services/WooCommerceService'))
const SEOService = lazy(() => import('./pages/services/SEOService'))
const DomainHostingService = lazy(() => import('./pages/services/DomainHostingService'))
const EmailSecurityService = lazy(() => import('./pages/services/EmailSecurityService'))
const DigitalSignageService = lazy(() => import('./pages/services/DigitalSignageService'))
const PrintDesignService = lazy(() => import('./pages/services/PrintDesignService'))
const ServiceCityPage = lazy(() => import('./pages/services/ServiceCityPage'))
const Blog = lazy(() => import('./pages/Blog'))
const BlogPost = lazy(() => import('./pages/BlogPost'))
const Booking = lazy(() => import('./pages/Booking'))
const Impressum = lazy(() => import('./pages/legal/Impressum'))
const Datenschutz = lazy(() => import('./pages/legal/Datenschutz'))
const AGB = lazy(() => import('./pages/legal/AGB'))
const NotFound = lazy(() => import('./pages/NotFound'))

function App() {
  return (
    <>
      <Helmet>
        <html lang="de" />
      </Helmet>

      <div className="min-h-screen bg-white dark:bg-dark-900 transition-colors duration-300">
        <ScrollToTop />
        <Navbar />

        <main id="main-content" className="pt-16 lg:pt-20">
          <Suspense fallback={<div className="min-h-screen" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              {/* Web & Design — overview + detail pages */}
              <Route path="/services/web" element={<WebdesignOverview />} />
              <Route path="/services/webdesign" element={<WebdesignService />} />
              <Route path="/services/wordpress" element={<WordPressService />} />
              {/* E-Commerce — overview + detail page */}
              <Route path="/services/ecommerce" element={<EcommerceOverview />} />
              <Route path="/services/shopify" element={<ShopifyService />} />
              <Route path="/services/woocommerce" element={<WooCommerceService />} />
              {/* SEO — new page */}
              <Route path="/services/seo" element={<SEOService />} />
              {/* Other services */}
              <Route path="/services/domains" element={<DomainHostingService />} />
              <Route path="/services/email-security" element={<EmailSecurityService />} />
              <Route path="/services/digital-signage" element={<DigitalSignageService />} />
              <Route path="/services/print-design" element={<PrintDesignService />} />
              {/* City landing pages */}
              <Route path="/services/:serviceSlug/:citySlug" element={<ServiceCityPage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/termin" element={<Booking />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<AGB />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>

        <Footer />
        <CookieBanner />
      </div>
    </>
  )
}

export default App
